import { Edit, SimpleForm, TextInput, maxLength, minLength, required } from 'react-admin';

const NotificationEdit = () => {
  const validateTitle = [required(), minLength(3), maxLength(30)];
  const validateNotificationTitle = [required(), minLength(3), maxLength(30)];
  const validateNotificationText = [required(), minLength(3), maxLength(200)];

  return (
    <Edit title="Создание уведомления">
      <SimpleForm redirect="list">
        <TextInput label="Название" source="title" validate={validateTitle} />
        <TextInput label="Заголовок уведомления" source="notificationTitle" validate={validateNotificationTitle} />
        <TextInput label="Текст уведомления" source="notificationBody" validate={validateNotificationText} multiline />
      </SimpleForm>
    </Edit>
  );
};

export default NotificationEdit;
